export const ru = {
    advertisement: 'Реклама',
    'agency-client-help-link': 'Отдел клиентского сервиса Яндекса',
    'common-help-link': 'Отдел клиентского сервиса',
    'self-agency-help-link': 'Отдел по работе с рекламными агентствами'
};
